import React, { useState } from "react";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import "./UndoCompletedTasks.css";

const HEADING = "Undo Completed Tasks"; // change the heading text here if needed

// onSave(rows) - connect your API here
const UndoCompletedTasks = ({ onSave }) => {
  const [rows, setRows] = useState([]); // [{ name }]
  const n = rows.length;
  const entries = `Showing ${n ? 1 : 0} to ${n} of ${n} entries`;

  return (
    <div className="uc-page">
      <div className="uc-panel">
        <h3 className="uc-title">{HEADING}</h3>

        <div className="uc-top">
          <span className="uc-entries">{entries}</span>
          <button type="button" className="uc-btn uc-add" onClick={() => setRows([...rows, { name: "" }])}>
            <span className="uc-plus">+</span> Add
          </button>
        </div>

        <table className="uc-table">
          <thead>
            <tr>
              <th>Name</th>
              {n > 0 && <th className="uc-x" />}
            </tr>
          </thead>
          <tbody>
            {n === 0 ? (
              <tr><td className="uc-empty">No data available in table</td></tr>
            ) : (
              rows.map((r, i) => (
                <tr key={i}>
                  <td>
                    <input
                      className="uc-input"
                      value={r.name}
                      onChange={(e) => setRows(rows.map((x, j) => (j === i ? { ...x, name: e.target.value } : x)))}
                    />
                  </td>
                  <td className="uc-x">
                    <button type="button" className="uc-ibtn" title="Delete" onClick={() => setRows(rows.filter((_, j) => j !== i))}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="uc-foot">
          <span>{entries}</span>
          <span className="uc-arrows">‹ &nbsp; ›</span>
        </div>

        <button type="button" className="uc-btn uc-save" onClick={() => onSave && onSave(rows)}>
          <FaPencilAlt /> Save
        </button>
      </div>
    </div>
  );
};

export default UndoCompletedTasks;